import { Pipe } from "@angular/core";
import { AddressModel } from "../../models/data/address.model";
import { AddressPipeLineSeparator, AddressPipeSecondaryAddressFormat } from "../../enums/base.enums";


@Pipe({
  name: "Address"
})
export class AddressPipe {

  transform(
    address: AddressModel | undefined,
    secondaryAddressFormat: AddressPipeSecondaryAddressFormat,
    lineSeparator: AddressPipeLineSeparator = AddressPipeLineSeparator.Html): string {
    if (!address) {
      return '';
    }

    let lines: string[] = [];

    switch (secondaryAddressFormat) {
      case AddressPipeSecondaryAddressFormat.Inline:
        if (address.primaryAddress && address.secondaryAddress) {
          lines.push(`${address.primaryAddress}, ${address.secondaryAddress}`);
        }
        break;
      case AddressPipeSecondaryAddressFormat.NewLine:
        if (address.primaryAddress) {
          lines.push(address.primaryAddress);
        }
        if (address.secondaryAddress) {
          lines.push(address.secondaryAddress);
        }
        break;
      case AddressPipeSecondaryAddressFormat.None:
        if (address.primaryAddress) {
          lines.push(address.primaryAddress);
        }
        break;
      default:
        if (address.primaryAddress) {
          lines.push(address.primaryAddress);
        }
        if (address.secondaryAddress) {
          lines.push(address.secondaryAddress);
        }
        break;
    }

    if (address.city || address.stateProvince || address.primaryZip) {
      let cityLine = [address.city, address.stateProvince.abbreviation]
        .filter(part => part)
        .join(', ');
      const zip = address.secondaryZip ? `${address.primaryZip}-${address.secondaryZip}` : address.primaryZip;
      cityLine = `${cityLine} ${zip}`;
      lines.push(cityLine);
    }

    return lines.join(lineSeparator);

  }
}